import {
  ActionsPopup,
  AssessmentCard,
  AssessmentTopicPopup,
  ClassAndSubjectPopup,
  FilterSortPopup,
  IClassAndSubjectSelected,
  IStyles,
  Loader,
  ManageHomeworkCard,
  ModeOfConductionDropdown,
  PrimaryButton,
  SecondaryButton,
  SecondaryOutlinedButton,
  SelectMenu,
  ShimmerManageHwCard,
  assessmentFilterTypes,
  deserify,
  getLocalStorage,
  pxToRem,
  pxTovW,
  theme,
  useCommonServiceClientContext,
  ConductionButtonsComponent,
  IconWrapper,
  useFeatureEnabled,
  ModeOfConductionStringType,
  FeatureGateName,
} from '@geneo2-web/shared-ui';
import { useFeatureGate } from '../../../utils/customHooks';
import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Pagination,
  Typography,
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { ProfileRolesEnum } from '@protos/user_management/ums.db_pb';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../../../app/Context/GlobalContextProvider';
import { TabComp } from '../../../components/TabComp';
import {
  useAppDispatch,
  useAppSelector,
  useDeserifiedSelector,
} from '../../../reduxStore/reduxHooks';
import {
  ASSESMENT_LIBRARY,
  ASSESSMENT_CREATE,
  ASSESSMENT_CURRENT,
  FORMATIVE,
  HOME,
  HOMEWORK,
  HOMEWORK_CHAPTER_SELECTION,
  HOMEWORK_COMPLETED,
  HOMEWORK_ONGOING,
  QPG,
} from '../../../routeHandling/RoutesNomenclature';
import { getSubjectsMap, subjectsWithClass } from '../../../utils/icons';
import { interactionEvent } from '../../Auth/auth.events';
import {
  setClassAndSubjectInfo,
  setToastInfo,
} from '../../Home/reducer/homeDashboard.slice';
import {
  setAssessmentCreationType,
  setCourseIndexInfo,
  setCreatedAssessmentStatus,
  setFAAssessmentConfig,
  setFAEditStep,
  setFASelectedChapterData,
  setFetchedAssessmentDetails,
  setModuleFilteredQuestions,
  setQPGEditStep,
  setCurrentQPGTemplateInfo,
  setQPGGeneratedTemplates,
  setQPGSelectedChapterData,
  setQPGSettingsConfig,
  setSelectedTasksInfo,
  setQPGContent,
  setQPGFormatDetails,
  setFAContent,
  setFaFormatDetails,
} from '../../Assessment/reducer/assessmentFlow.slice';
import {
  setAssessmentListData,
  setAssignedData,
  setDraftData,
  setEndedData,
  setHwInfoData,
  setModeOfConduction,
  setSelectedAssessmentId,
} from '../reducer/manageHomework.slice';
import AssementRedirectionComponent from './AssementRedirectionComponent';
import AssementSelectionPopup from './AssementSelectionPopup';
import {
  AssessmentEnum,
  AssignmentConfigEnum,
  ModeOfConductionEnum,
} from '@protos/learning_management/lms.db_pb';
import {
  resetSelectedChapter,
  resetSelectedTopic,
  setAssessmentData,
} from '../../Assessment/reducer/assessmentFlow.slice';
import { useDownloadContext } from '../../../app/Context/DownloadContextProviderV2';
import { AssessmentTask } from '@protos/learning_management/lms.assessment.common.apis_pb';
import {
  getModeOfConductionEnum,
  getModeOfConductionString,
} from '../../../utils/functions';
import { resetClickerAssessmentState } from '../../Assessment/ClickerAssessment/reducer/clickerAssessment.slice';
import {
  ALL_MODES,
  convertToSequenceInfo,
} from '../../Assessment/Common/ReviewAssessment/functions';
import { QPGSelectMultiSubjectsPopup } from '../components/QPGSelectMultiSubjectsPopup';
import { FASelectMultiSubjectsPopup } from '../../Assessment/FormativeAssessmentV2/FASelectMultiSubjectsPopup/FASelectMultiSubjectsPopup';
import { getSubjectListForAssessmentCard } from '../../Assessment/utils/assessment.utils';
import { ConductionMode } from 'libs/shared-ui/src/components/composites/ConductionButtonsComponent';
import { Feature } from '@protos/school_management/school.db_pb';
import { ProjectSubjectSelectionPopup } from '../../Laboratory/components/ProjectSubjectSelectionPopup';
import { resetProjectFlow } from '../../Laboratory/CreateProject/reducer/projectFlow.Slice';
import { useProjectAssessmentEnabled } from '../../../utils/customHooks';

declare global {
  interface Window {
    Android: any;
  }
}

interface IAssessmentTypes {
  name: string;
  id: AssessmentEnum;
}
const styles: IStyles = {
  root: {
    // width: '100vw',
    cursor: 'pointer',
    // display: 'flex',
    // flexDirection: 'column',
    // justifyContent: 'center',
    paddingLeft: { xs: pxToRem(20), lg: pxTovW(241) },
    paddingTop: { xs: pxToRem(20), lg: pxTovW(33) },
    paddingBottom: { xs: pxToRem(50), lg: pxTovW(40) },
    paddingRight: { xs: pxToRem(20), lg: pxTovW(241) },
    boxSizing: 'border-box',
    overflowX: 'hidden',
    overflowY: 'hidden',
    // backgroundColor: 'red',
  },
  assessmentBtnBox: {
    paddingBottom: { xs: pxToRem(24), md: pxTovW(78) },
    display: 'flex',
    flexDirection: { xs: 'column' },
    gap: { xs: pxToRem(22), md: pxTovW(74) },
    width: '100%',
  },
  assessmentTxt: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    justifyContent: { xs: 'flex-start', md: 'space-between' },
    gap: { xs: pxToRem(22), md: 0 },
  },
  header: {
    width: '100%',
    // height: { md: pxTovW(25) },
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    paddingBottom: { xs: pxToRem(20), md: pxTovW(37) },
    // paddingLeft: { xs: pxToRem(20), md: 0 },
  },
  inputBox: {
    width: '100%',
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    // flexDirection: 'column',
    // backgroundColor: 'red',
    // justifyContent: 'center',
    justifyContent: { xs: 'space-between', md: 'center' },
    gap: { xs: pxToRem(10), md: pxTovW(15) },
  },
  inputFeild: {
    // backgroundColor: 'red',
    display: 'flex',
    height: { xs: pxToRem(50), md: pxTovW(56) },
    borderRadius: { xs: pxToRem(10), md: pxTovW(15) },
    border: '1px solid #CCE6FE',
    width: { xs: pxToRem(311), lg: pxTovW(457) },
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  inputFieldBox: {
    // border: '1px solid black',
    display: 'flex',
    justifyContent: 'center',
    paddingTop: { xs: pxToRem(10), md: pxTovW(29) },
  },
};

export const ManageHomework = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathSegments = location.pathname.split('/');
  const { isOffline } = useDownloadContext();
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isOpenSelectModeOfConduction, setIsOpenSelectModeOfConduction] =
    useState(false);

  const [error, setError] = useState<any>(null);
  const teacher_profile_id = getLocalStorage('userId');
  const largeScreen = useMediaQuery(theme.breakpoints.up('md'));
  const isIpad = useMediaQuery(theme.breakpoints.down('lg'));
  //Draft
  const mapData = ['Assigned', 'Ended'];
  const [selectedHomework, setSelectedHomework] = useState<
    AssessmentTask | undefined
  >();
  const [chapterListPopup, setChapterListPopup] = useState(false);
  const { isIpadOnly } = useGlobalContext();
  const subMap = getSubjectsMap();
  const dispatch = useAppDispatch();
  const [count, setCount] = useState(0);
  const { user_info } = deserify(useAppSelector((state) => state.auth));
  const class_subject_info = useDeserifiedSelector(
    (state) => state.homeDashboard.class_subject_info
  );
  const {
    assessment_list_data,
    draft_homework,
    assigned_homework,
    ended_homework,
    hw_info,
  } = deserify(useAppSelector((state) => state.manageHomework));

  const { assesment_flow_data, assesment_creation_type } = deserify(
    useAppSelector((state) => state.assessment)
  );
  const featureInfo = user_info?.schoolDetails[0]?.featuresPlanInfo;
  const isOMREnabled = useFeatureEnabled(featureInfo, Feature.OMR_ENABLED);
  const isLiveQuizEnabled = useFeatureEnabled(
    featureInfo,
    Feature.WEB_BASED_LIVE_QUIZ
  );

  const [value, setValue] = useState(
    location.state?.assessmentState === 'Assigned'
      ? mapData[0]
      : location.state?.assessmentState === 'Ended'
        ? mapData[1]
        : mapData[0]
  );
  const [pageNumber, setPageNumber] = useState(1);
  const {
    LmsAssessmentCommonAPIServiceV1ClientWithStatusCodeHandler,
    LmsAssessmentTeacherAPIServiceV1WithStatusCodeHandler,
  } = useCommonServiceClientContext();
  const { setSelectedFunction } = useGlobalContext();

  //^ SubjectPopup
  const [modalState, setModalState] = useState(false);
  const [deletionPopup, setDeletionPopup] = useState<boolean>(false);
  const learningHomeworkEnabled = useFeatureGate(
    FeatureGateName.learningHomeworkEnabled
  );
  const [assessmentSelectionPopupDisplay, setAssessmentSelectionPopupDisplay] =
    useState(false);
  const [deleteAssessmentInfo, setDeleteAssessmentInfo] = useState<{
    assessmentId: bigint;
    assessmentType: AssessmentEnum;
  }>({
    assessmentId: BigInt(0),
    assessmentType: AssessmentEnum.ASSESSMENT_UNDEFINED,
  });
  const [selectedAssessment, setSelectedAssessment] = useState<
    AssessmentEnum | undefined
  >();
  const [navigateToLibrary, setNavigateToLibrary] = useState(false);
  const [navigateToQuestionBank, setNavigateToQuestionBank] = useState(false);
  const [noNavigationClassSelection, setNoNavigationClassSelection] =
    useState(false);
  const [searchByAssessType, setSearchByAssessType] = useState<
    IAssessmentTypes | undefined
  >();
  const [isNewHomeworkPopup, setIsNewHomeworkPopup] = useState(false);
  const { ContentCommonAPIServiceV1ClientWithStatusCodeHandler } =
    useCommonServiceClientContext();
  const teacher_id = getLocalStorage('userId');

  const isModeSupported = (mode: ModeOfConductionEnum) => {
    switch (mode) {
      case ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_CLICKER:
        return class_subject_info?.isClickerSupported;
      case ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR:
        return isOMREnabled;
      case ModeOfConductionEnum.MODE_OF_CONDUCTION_WEB_LIVE:
        return isLiveQuizEnabled;
      default:
        return true; // App always supported
    }
  };
  const modeOptions = [
    {
      name: 'All',
      id: ModeOfConductionEnum.MODE_OF_CONDUCTION_UNDEFINED,
    },
    ...ALL_MODES.filter((m) => isModeSupported(m.id)),
  ];

  // const [modeOfConductionValue, setModeOfConductionValue] = useState<string>(
  //   location.state?.modeOfConduction === 'clicker'
  //     ? 'Geneo Clicker'
  //     : getModeOfConductionString(
  //         ModeOfConductionEnum.MODE_OF_CONDUCTION_UNDEFINED
  //       ) || 'All'
  // );
  const [modeOfConductionValue, setModeOfConductionValue] = useState<
    ModeOfConductionStringType | 'All'
  >(
    location.state?.modeOfConduction === 'clicker'
      ? 'Geneo Clicker'
      : getModeOfConductionString(
        ModeOfConductionEnum.MODE_OF_CONDUCTION_UNDEFINED
      ) || 'All'
  );

  const [faMultiSubjectsPopup, setFAMultiSubjectsPopup] =
    useState<boolean>(false);
  const [qpgSelectMultiSubjectsPopup, setQPGSelectMultiSubjectsPopup] =
    useState<boolean>(false);
  const [selectedMode, setSelectedMode] = useState<ConductionMode | undefined>(
    undefined
  );
  const [openProjectPopup, setOpenProjectPopup] = useState(false);

  const backButtonClick = async () => {
    navigate(HOME);
  };

  const matchedSection = user_info?.teachClassSubjects.find(
    (item) => item.sectionId === class_subject_info?.sectionId
  );

  const isClickerEnabled = class_subject_info?.isClickerSupported;
  const isProjectAssessmentEnabled = useProjectAssessmentEnabled();

  const handleChange = async (newValue: string) => {
    await interactionEvent({
      context: 'Manage_previous_assessment',
      name: newValue.toUpperCase(),
      pathSegments: pathSegments,
      isOffline: isOffline,
    });
    setValue(newValue);
    // setCountValue(newValue);
    setPageNumber(1);
  };

  // --------------------------------------------------------------

  const ChapterListPopupHandler = (assessment: AssessmentTask) => {
    setSelectedHomework(assessment);
    setChapterListPopup(true);
  };

  // --------------------------------------------------------------

  const cardClickHandler = async (
    homeworkId: bigint,
    modeOfConduction: ModeOfConductionEnum = ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_APP,
    moduleId?: number
  ) => {
    // console.log('homeworkId', homeworkId);

    await interactionEvent({
      context: value === 'Assigned' ? 'Assigned' : 'Ended',
      name:
        value === 'Assigned' ? 'ASSIGNED_HOMEWORK_OPEN' : 'ENDED_HOMEWORK_OPEN',
      pathSegments: pathSegments,
      isOffline: isOffline,
    });

    switch (value) {
      case 'Assigned':
        dispatch(setSelectedAssessmentId(homeworkId));
        if (
          modeOfConduction ===
          ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_CLICKER
        ) {
          navigate('/clicker-assessment-manage');
        } else {
          // Live Quiz mode falls through here too — OngoingHomework itself
          // special-cases MODE_OF_CONDUCTION_WEB_LIVE (same as it already
          // does for OMR) rather than this routing to a dedicated page.
          navigate(HOMEWORK_ONGOING);
        }
        break;
      case 'Ended':
        dispatch(setSelectedAssessmentId(homeworkId));
        if (
          modeOfConduction ===
          ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_CLICKER
        ) {
          navigate('/clicker-assessment-manage');
        } else {
          navigate(HOMEWORK_COMPLETED);
        }
        break;
      case 'Draft':
        if (moduleId) {
          getHomeworkDetails(homeworkId, moduleId.toString());
        }
        break;
      default:
        break;
    }
  };

  // --------------------------------------------------------------

  const getHomeworkDetails = async (homeworkId: bigint, moduleId: string) => {
    try {
      const response =
        await LmsAssessmentCommonAPIServiceV1ClientWithStatusCodeHandler.fetchAssessmentContent(
          {
            personId: teacher_profile_id,
            personType: ProfileRolesEnum.PROFILE_ROLE_TEACHER,
            assessmentId: homeworkId,
          }
        );
      if (response.data) {
        const HwData = response.data;
        dispatch(
          setCreatedAssessmentStatus(HwData.assessment?.taskCreationStatus)
        );
        dispatch(
          setModuleFilteredQuestions({ questions: HwData.assessmentContent })
        );
        dispatch(setFetchedAssessmentDetails(HwData.assessment));
        const sequenceInfo = convertToSequenceInfo(
          HwData.questionsSequenceInfo
        );
        if (sequenceInfo) {
          dispatch(setSelectedTasksInfo(sequenceInfo));
        }
        navigate(`${HOMEWORK}${ASSESSMENT_CURRENT}/${moduleId}`);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // --------------------------------------------------------------

  const fetchAssessmentsByModule = async (subjectId?: number) => {
    try {
      setLoading(true);
      const response =
        await LmsAssessmentCommonAPIServiceV1ClientWithStatusCodeHandler.fetchAssessmentsByModule(
          {
            personId: teacher_profile_id,
            personType: ProfileRolesEnum.PROFILE_ROLE_TEACHER,
            subjectId: subjectId,
            assessmentType: AssessmentEnum.ASSESSMENT_HOMEWORK,
          }
        );
      if (response?.data) {
        dispatch(setAssessmentData(response.data));
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  // --------------------------------------------------------------

  const classAndsubjectClickHandler = async (
    inputClassInfo: IClassAndSubjectSelected
  ) => {
    dispatch(setClassAndSubjectInfo(inputClassInfo));
    setModalState(false);
    if (navigateToQuestionBank) {
      await fetchChapterTopicData(inputClassInfo.subjectId);
      navigate('/question-bank');
      return;
    }
    // if (navigateToLibrary && !selectedMode && isClickerEnabled) {
    //   setIsOpenSelectModeOfConduction(true);
    //   return;
    // }
    if (navigateToLibrary) {
      if (
        inputClassInfo?.isClickerSupported ||
        isOMREnabled ||
        isLiveQuizEnabled
      ) {
        if (selectedMode) {
          dispatch(setModeOfConduction(getModeOfConductionEnum(selectedMode)));
          navigate(`${ASSESMENT_LIBRARY}`);
        } else {
          setIsOpenSelectModeOfConduction(true);
        }
      } else {
        dispatch(setModeOfConduction(undefined));
        navigate(`${ASSESMENT_LIBRARY}`);
      }
    } else if (selectedAssessment) {
      createAssessmentNavigation();
    } else if (!noNavigationClassSelection) {
      setAssessmentSelectionPopupDisplay(true);
    }
    setPageNumber(1);
    await interactionEvent({
      context: 'Choose_Class_&_Subject',
      name: inputClassInfo.subject.trim().toUpperCase().replace(/\s+/g, '_'),
      pathSegments: pathSegments,
      isOffline: isOffline,
    });
  };

  // --------------------------------------------------------------

  const onChangeModeOfConduction = async (
    modeOfConduction: ModeOfConductionStringType
  ) => {
    setModeOfConductionValue(modeOfConduction);
    await interactionEvent({
      context: 'mode_of_conduction',
      name: modeOfConduction.toUpperCase().replace(/ /g, '_'),
      pathSegments: pathSegments,
      isOffline: isOffline,
    });
  };

  // --------------------------------------------------------------

  const getTeacherAssessmentList = async (
    teacherId: string,
    assessentType?: AssessmentEnum,
    teacherModeofConduction?: ModeOfConductionEnum
  ) => {
    try {
      // if (
      //   (value === 'Draft' && draft_homework && !draft_homework[pageNumber]) ||
      //   (value === 'Assigned' &&
      //     assigned_homework &&
      //     !assigned_homework[pageNumber]) ||
      //   (value === 'Ended' && ended_homework && !ended_homework[pageNumber])
      // ) {
      //   setLoading(true);
      // } else {
      //   setLoading(false);
      // }
      setLoading(true);

      // const response = await LmsTeacherHWAPIsSer({
      //   teacherId: BigInt(teacherId),
      // });
      // const response =
      //   await LmsHomewokTeacherAPIServiceV1ClientWithStatusCodeHandler.getTeacherHomeworkList(
      //     {
      //       teacherId: BigInt(teacherId),
      //       sectionId: class_subject_info?.sectionId,
      //       subjectId: class_subject_info?.subjectId,
      //       pageNumber: pageNumber,
      //     }
      //   );

      const response =
        await LmsAssessmentTeacherAPIServiceV1WithStatusCodeHandler.getTeacherAssessmentsList(
          {
            teacherId: BigInt(teacherId),
            subjectId: class_subject_info?.subjectId,
            sectionId: class_subject_info?.sectionId,
            pageNumber: pageNumber,
            assessmentType: assessentType,
            modeOfConduction: teacherModeofConduction,
            // assessmentType: AssessmentEnum.ASSESSMENT_HOMEWORK,
          }
        );
      const data = response.assessmentList;
      // console.log(response.data);
      if (data?.assessmentList) {
        const hw_data = data?.assessmentList;
        const countInPagination = hw_data.assesmentListInfo?.countInPagination;

        dispatch(
          setDraftData({ ...draft_homework, [pageNumber]: hw_data.draft })
        );
        dispatch(
          setAssignedData({
            ...assigned_homework,
            [pageNumber]: hw_data.assigned,
          })
        );
        dispatch(
          setEndedData({ ...ended_homework, [pageNumber]: hw_data.ended })
        );

        dispatch(
          setHwInfoData({
            ...hw_info,
            hwListInfo: hw_data.assesmentListInfo,
            totalDraftPages: Math.ceil(
              (hw_data.assesmentListInfo?.draftCount || 0) /
              (countInPagination || 1)
            ),
            totalAssignedPages: Math.ceil(
              (hw_data.assesmentListInfo?.activeCount || 0) /
              (countInPagination || 1)
            ),
            totalEndedPages: Math.ceil(
              (hw_data.assesmentListInfo?.endedCount || 0) /
              (countInPagination || 1)
            ),
          })
        );
        // dispatch(
        //   setAssessmentInfoData({
        //     ...hw_info,
        //     assessmentListInfo: hw_data.assesmentListInfo,
        //     totalDraftPages: Math.ceil(
        //       (hw_data.assesmentListInfo?.draftCount || 0) /
        //         (countInPagination || 1)
        //     ),
        //     totalAssignedPages: Math.ceil(
        //       (hw_data.assesmentListInfo?.activeCount || 0) /
        //         (countInPagination || 1)
        //     ),
        //     totalEndedPages: Math.ceil(
        //       (hw_data.assesmentListInfo?.endedCount || 0) /
        //         (countInPagination || 1)
        //     ),
        //   })
        // );

        // setAssignedHomework(data.homeworkList.assigned);
        // setDraftHomework(data.homeworkList.draft);
        // setEndedHomework(data.homeworkList.ended);

        dispatch(setAssessmentListData(hw_data));
        // dispatch(setAssessmentListData(hw_data));
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setError(err);
      console.log(err);
    }
  };

  // --------------------------------------------------------------

  const sortData = (data: AssessmentTask[], sortvalue: any) => {
    switch (sortvalue) {
      case 'Score: High to Low':
        return data
          .slice()
          .sort(
            (a: AssessmentTask, b: AssessmentTask) =>
              (b.classScore || 0) - (a.classScore || 0)
          );
      case 'Score: Low to High':
        return data
          .slice()
          .sort(
            (a: AssessmentTask, b: AssessmentTask) =>
              (a.classScore || 0) - (b.classScore || 0)
          );
      case 'Date':
        return data
          .slice()
          .sort(
            (a: AssessmentTask, b: AssessmentTask) =>
              Number(a.assessmentTargetDate?.seconds) -
              Number(b.assessmentTargetDate?.seconds)
          );
        return data;
      case 'Submission':
        return data
          .slice()
          .sort(
            (a: any, b: any) =>
              (b.studentsSubmissionCount || 0) -
              (a.studentsSubmissionCount || 0)
          );
      case 'Difficulty':
        return data
          .slice()
          .sort((a: any, b: any) => b.difficultyLevel - a.difficultyLevel);
      default:
        return data;
    }
  };

  // --------------------------------------------------------------

  const SortFunction = async (sortvalue: string) => {
    if (value === 'Assigned' && assigned_homework) {
      const temp = assigned_homework[pageNumber].slice() || [];
      const sortedData = sortData(temp, sortvalue);
      dispatch(
        setAssignedData({ ...assigned_homework, [pageNumber]: sortedData })
      );
    } else if (value === 'Ended' && ended_homework) {
      const temp = ended_homework[pageNumber].slice() || [];
      const sortedData = sortData(temp, sortvalue);
      dispatch(setEndedData({ ...ended_homework, [pageNumber]: sortedData }));
    } else if (value === 'Draft' && draft_homework) {
      const temp = draft_homework[pageNumber].slice() || [];
      const sortedData = sortData(temp, sortvalue);
      dispatch(setDraftData({ ...draft_homework, [pageNumber]: sortedData }));
    }
    await interactionEvent({
      context: 'Sort_by',
      name: sortvalue.toUpperCase().replace(/ /g, '_').replace(/[:.]/g, ''),
      pathSegments: pathSegments,
      isOffline: isOffline,
    });
  };

  // --------------------------------------------------------------

  const showPagination = () => {
    return (
      (value === 'Draft' && hw_info && hw_info.totalDraftPages > 0) ||
      (value === 'Assigned' && hw_info && hw_info.totalAssignedPages > 0) ||
      (value === 'Ended' && hw_info && hw_info.totalEndedPages > 0)
    );
  };

  // --------------------------------------------------------------

  const deleteAssessment = async (assessmentId: bigint) => {
    try {
      setDeleteLoading(true);
      const response =
        await LmsAssessmentTeacherAPIServiceV1WithStatusCodeHandler.deleteTeacherCreatedAssessment(
          {
            assessmentId: assessmentId,
            teacherId: BigInt(teacher_profile_id),
          }
        );
      if (response) {
        getTeacherAssessmentList(
          teacher_profile_id,
          searchByAssessType?.id,
          getModeOfConductionEnum(
            modeOfConductionValue === 'All' ? undefined : modeOfConductionValue
          )
        );
        setDeleteLoading(false);
        dispatch(
          setToastInfo({
            variant: 'success',
            label: 'Assessment Deleted Successfully',
            open: true,
          })
        );
      } else {
        // Handle case where response is falsy (API call failed but no error was thrown)
        setDeleteLoading(false);
        dispatch(
          setToastInfo({
            variant: 'error',
            label: 'Failed to delete assessment. Please try again.',
            open: true,
          })
        );
      }
    } catch (err) {
      console.log(err);
      setDeleteLoading(false);
      dispatch(
        setToastInfo({
          variant: 'error',
          label: 'Error occurred while deleting assessment',
          open: true,
        })
      );
    }
  };

  // --------------------------------------------------------------

  const onDeleteClick = async (assessment: AssessmentTask) => {
    if (assessment.assessmentType !== AssessmentEnum.ASSESSMENT_UNDEFINED) {
      setDeletionPopup(true);
      setDeleteAssessmentInfo({
        assessmentId: assessment.assessmentId,
        assessmentType:
          assessment.assessmentType ?? AssessmentEnum.ASSESSMENT_UNDEFINED,
      });
    }
  };

  // --------------------------------------------------------------

  const redirectToHomeworkChapterSelection = async (subjectId: number) => {
    await interactionEvent({
      context: 'Manage_homework',
      name: 'NEW_HOMEWORK',
      pathSegments: pathSegments,
      isOffline: isOffline,
    });

    navigate(`${HOMEWORK_CHAPTER_SELECTION}/${subjectId}`);
  };

  // --------------------------------------------------------------

  const createAssessmentNavigation = async () => {
    // if (selectedMode) {
    // const finalMode = selectedMode || 'Geneo App'; // default case
    // dispatch(setModeOfConduction(getModeOfConductionEnum(finalMode)));
    // }
    const modeOfConduction = resolveModeOfConduction(
      selectedMode,
      class_subject_info?.isClickerSupported,
      isOMREnabled
    );
    dispatch(setModeOfConduction(modeOfConduction));

    switch (selectedAssessment) {
      case AssessmentEnum.ASSESSMENT_HOMEWORK:
        navigate(
          `${HOMEWORK_CHAPTER_SELECTION}/${class_subject_info?.subjectId}`
        );
        break;
      // case AssessmentEnum.ASSESSMENT_FORMATIVE_ASSESSMENT:
      //   navigate(
      //     `${FORMATIVE}${ASSESSMENT_CREATE}/${class_subject_info?.subjectId}`
      //   );
      //   break;
      case AssessmentEnum.ASSESSMENT_FORMATIVE_ASSESSMENT:
        dispatch(
          setFaFormatDetails({
            ...(class_subject_info && {
              selectedClass: {
                id: class_subject_info.classId,
                name: `Class ${class_subject_info.classname}`,
              },
            }),
            selectedSubjects: [{ name: '', id: 0 }],
          })
        );
        dispatch(setFAContent(undefined));
        setAssessmentSelectionPopupDisplay(false);
        setFAMultiSubjectsPopup(true);
        break;
      // case AssessmentEnum.ASSESSMENT_QUESTION_PAPER:
      //   navigate(
      //     `${QPG}${ASSESSMENT_CREATE}/${class_subject_info?.subjectId}`,
      //     {
      //       state: {
      //         redirectionPath: location.pathname,
      //       },
      //     }
      //   );
      //   break;
      case AssessmentEnum.ASSESSMENT_QUESTION_PAPER:
        dispatch(
          setQPGFormatDetails({
            ...(class_subject_info && {
              selectedClass: {
                id: class_subject_info.classId,
                name: `Class ${class_subject_info.classname}`,
              },
            }),
            selectedSubjectsAndMarks: [
              { subject: { name: '', id: 0 }, marks: undefined },
            ],
            selectedTemplates: [{ name: '', id: 0 }],
          })
        );
        dispatch(setQPGContent(undefined));
        setAssessmentSelectionPopupDisplay(false);
        setQPGSelectMultiSubjectsPopup(true);
        break;
      case AssessmentEnum.ASSESSMENT_PROJECT:
        dispatch(
          setFaFormatDetails({
            ...(class_subject_info && {
              selectedClass: {
                id: class_subject_info.classId,
                name: `Class ${class_subject_info.classname}`,
              },
            }),
            selectedSubjects: [{ name: '', id: 0 }],
          })
        );
        dispatch(setFAContent(undefined));
        setAssessmentSelectionPopupDisplay(false);
        setOpenProjectPopup(true);
        break;
      default:
        return;
    }
    await interactionEvent({
      context: 'Choose_Type_of_Assessment',
      name: 'PROCEED',
      pathSegments: pathSegments,
      isOffline: isOffline,
    });
  };

  // --------------------------------------------------------------

  const createLibraryNavigation = async () => {
    if (!class_subject_info) {
      setNavigateToLibrary(true);
      setModalState(true);
      // dispatch(resetAssessmentFlowState());
    } else {
      if (isClickerEnabled || isOMREnabled || isLiveQuizEnabled) {
        //open the dialog if any of the mode is supported for the selected class/subject or school
        setIsOpenSelectModeOfConduction(true);
      } else {
        dispatch(setModeOfConduction(undefined));
        navigate(`${ASSESMENT_LIBRARY}`);
      }
    }
    await interactionEvent({
      context: 'Assessment',
      name: 'CHOOSE_FROM_LIBRARY',
      pathSegments: pathSegments,
      isOffline: isOffline,
    });
  };

  // --------------------------------------------------------------

  const optionSelectionHandler = async (assessmentType: AssessmentEnum) => {
    setSelectedAssessment(assessmentType);
    const mode = resolveModeOfConduction(
      selectedMode,
      class_subject_info?.isClickerSupported,
      isOMREnabled
    );
    dispatch(
      setAssessmentCreationType({
        ...assesment_creation_type,
        asessmentType: assessmentType,
        creationType: 'Create',
        modeOfConduction: mode,
      })
    );
  };

  // --------------------------------------------------------------

  const openAssessmentTypePopup = async () => {
    if (!class_subject_info) {
      setModalState(true);
    } else {
      setAssessmentSelectionPopupDisplay(true);
      //Temporarily disabling the popup till FA creation flow is not ready
      // navigate(
      //   `${HOMEWORK_CHAPTER_SELECTION}/${class_subject_info?.subjectId}`
      // );
    }
    await interactionEvent({
      context: 'Assessment',
      name: 'CREATE_ASSESSMENT',
      isOffline: isOffline,
      pathSegments: pathSegments,
    });
  };

  // --------------------------------------------------------------

  // useEffect(() => {
  //   fetchAssessmentsByModule(class_subject_info?.subjectId);
  // }, [class_subject_info]);

  useEffect(() => {
    if (modalState === false) {
      setIsNewHomeworkPopup(false);
    }
  }, [modalState]);

  useEffect(() => {
    // setValue(
    //   location.state?.assessmentState === 'Assigned' ? mapData[0] : mapData[1]
    // );
    setSelectedFunction(() => backButtonClick);
    (async () => {
      await interactionEvent({
        url: 'Teacher_homework_manage',
        context: 'Manage_Homework',
        name: mapData[0].toUpperCase(),
        isOffline: isOffline,
      });
    })();
    // setCount(assignedHomework?.length || 0);
    dispatch(setFASelectedChapterData(undefined));
    dispatch(setFAAssessmentConfig(undefined));
    dispatch(setCourseIndexInfo(undefined));
    dispatch(setFAEditStep(undefined));
    dispatch(resetSelectedChapter());
    dispatch(resetSelectedTopic());
    dispatch(resetClickerAssessmentState());
    dispatch(setQPGEditStep(undefined));
    dispatch(setCurrentQPGTemplateInfo([]));
    dispatch(setQPGSelectedChapterData(undefined));
    dispatch(setQPGSettingsConfig(undefined));
    dispatch(setQPGGeneratedTemplates([]));
    if (isProjectAssessmentEnabled) dispatch(resetProjectFlow());
    return () => {
      setSelectedFunction(null);
    };
  }, []);

  useEffect(() => {
    if (teacher_profile_id) {
      getTeacherAssessmentList(
        teacher_profile_id,
        searchByAssessType?.id,
        getModeOfConductionEnum(
          modeOfConductionValue === 'All' ? undefined : modeOfConductionValue
        )
      );
    }
    dispatch(setModeOfConduction(undefined));
  }, [
    class_subject_info?.classId,
    pageNumber,
    value,
    searchByAssessType,
    modeOfConductionValue,
    class_subject_info?.sectionId,
    class_subject_info?.subjectId,
  ]);

  // --------------------------------------------------------------

  const fetchChapterTopicData = async (subjectId?: number) => {
    try {
      setLoading(true); // Start loading
      setError(null); // Reset previous error if any
      setPageNumber(1);

      const chapterTopicData =
        await ContentCommonAPIServiceV1ClientWithStatusCodeHandler.fetchCourseIndexInfo(
          {
            personId: BigInt(teacher_id),
            personType: ProfileRolesEnum.PROFILE_ROLE_TEACHER,
            subjectId: subjectId || class_subject_info?.subjectId,
          }
        );
      if (chapterTopicData) {
        dispatch(setCourseIndexInfo(chapterTopicData?.data));
      }
    } catch (error) {
      dispatch(
        setToastInfo({
          label: 'Error fetching Chapter Topic Data',
          variant: 'error',
          open: true,
        })
      );
    } finally {
      setLoading(false); // Stop loading
    }
  };

  // --------------------------------------------------------------

  const handleExploreQuestionBankClick = async () => {
    if (class_subject_info) {
      await fetchChapterTopicData();
      navigate('/question-bank');
      setNavigateToQuestionBank(false);
    } else {
      setNavigateToQuestionBank(true);
      setModalState(true); //todo:add fetch chapter topic and question redirection from class subject popup
    }
  };

  // --------------------------------------------------------------

  const resolveModeOfConduction = (
    selectedMode?: ConductionMode,
    isClickerSupported?: boolean,
    isOMREnabled?: boolean
  ): ModeOfConductionEnum => {
    if (selectedMode === 'Geneo Clicker') {
      return isClickerSupported
        ? ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_CLICKER
        : ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_APP;
    }
    if (selectedMode === 'OMR Test') {
      return isOMREnabled
        ? ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR
        : ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_APP;
    }
    if (selectedMode === 'Geneo Live Quiz') {
      return ModeOfConductionEnum.MODE_OF_CONDUCTION_WEB_LIVE;
    }
    if (selectedMode === 'Geneo App') {
      return ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_APP;
    }
    return !selectedMode && isClickerSupported
      ? ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_CLICKER
      : ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_APP;
  };

  // --------------------------------------------------------------
  return deleteLoading === true ? (
    <Loader />
  ) : (
    <Box sx={styles.root}>
      <Box sx={styles.assessmentBtnBox}>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: { xs: pxToRem(20) },
            flexDirection: {
              xs: 'column',
              md: 'row',
            },
          }}
        >
          <Box sx={styles.assessmentTxt}>
            <Typography variant="h1">Assessment</Typography>
          </Box>

          <Button
            size="medium"
            onClick={handleExploreQuestionBankClick}
            startIcon={
              <IconWrapper
                name="search-blue-question-mark"
                customSx={{
                  height: { xs: pxToRem(20), md: pxTovW(24) },
                  width: { xs: pxToRem(20), md: pxTovW(24) },
                }}
                type="png"
                parentFolder="icons"
              />
            }
            sx={{
              display: 'flex',
              color: '#007BFF',
              fontWeight: 600,
              fontSize: { xs: pxToRem(14), md: pxTovW(16) },
              height: { xs: pxToRem(60), md: pxTovW(60) },
              width: { xs: '100%', md: pxTovW(290) },
              border: '1px solid #007BFF',
              borderRadius: pxToRem(8),
              paddingX: { xs: pxToRem(20), md: pxTovW(28) },
              paddingY: { xs: pxToRem(8), md: pxTovW(10) },
            }}
          >
            Explore Question Bank
          </Button>
        </Box>

        <Box>
          <AssementRedirectionComponent
            createClickHandler={openAssessmentTypePopup}
            libraryClickHandler={createLibraryNavigation}
            hwCount={
              assesment_flow_data?.assessmentListInfo?.totalAssessmentsCount
            }
          />
        </Box>
      </Box>
      <Box sx={styles.header}>
        <Typography variant="h1">Manage Previous Assessments</Typography>
      </Box>
      <Box>
        <TabComp
          handleChange={handleChange}
          mapData={mapData}
          stateValue={value}
          // count={count}
          count={
            value === 'Draft'
              ? hw_info?.hwListInfo?.draftCount || 0
              : value === 'Assigned'
                ? hw_info?.hwListInfo?.activeCount || 0
                : value === 'Ended'
                  ? hw_info?.hwListInfo?.endedCount || 0
                  : 0
          }
        />
      </Box>

      <Box sx={styles.inputFieldBox}>
        <Box sx={styles.inputBox}>
          {/* {largeScreen ? (
            <Box sx={styles.inputFeild}>
              <InputField
                value={'Daily Homework'}
                name="task_name"
                // onChange={changeDetailsHandler}
                variant="outlined"
              ></InputField>
              <ExpandMoreOutlinedIcon fontSize="medium" />
            </Box>
          ) : (
            <SecondaryButton withArrow>8A Science</SecondaryButton>
          )} */}
          <Box
            onClick={(e) => {
              setModalState(true);
              setNoNavigationClassSelection(true);
              setSelectedMode?.(undefined);
            }}
            sx={{ flex: { xs: 1, md: 'unset' } }}
          >
            {largeScreen ? (
              <SecondaryOutlinedButton
                size={isIpadOnly ? 'large' : 'medium'}
                witharrow={class_subject_info ? false : true}
                onClick={async () => {
                  await interactionEvent({
                    context: value,
                    name: 'CHOOSE_CLASS_SUBJECT',
                    pathSegments: pathSegments,
                    isOffline: isOffline,
                  });
                }}
              >
                {class_subject_info && class_subject_info.classname ? (
                  <Box
                    sx={{
                      display: 'flex',
                      width: '100%',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <Typography variant="h4">{`${class_subject_info?.classname} ${class_subject_info?.section} - ${class_subject_info?.subject}`}</Typography>
                    <CloseIcon
                      sx={{
                        color: 'common.black',
                        fontSize: { xs: pxToRem(14), md: pxTovW(18) },
                      }}
                      onClick={(ev) => {
                        ev.stopPropagation();
                        dispatch(setClassAndSubjectInfo(undefined));
                        dispatch(resetSelectedChapter());
                        dispatch(resetSelectedTopic());
                        setPageNumber(1);
                      }}
                    />
                  </Box>
                ) : (
                  <Typography variant="h4">Choose Class & Subject</Typography>
                )}
              </SecondaryOutlinedButton>
            ) : (
              <SecondaryButton
                witharrow
                onClick={async () => {
                  await interactionEvent({
                    context: value === 'Assigned' ? 'Assigned' : 'Ended',
                    name: 'CHOOSE_CLASS_SUBJECT',
                    pathSegments: pathSegments,
                    isOffline: isOffline,
                  });
                }}
              >
                <Typography variant="h5" fontWeight="bold" color="white">
                  {class_subject_info
                    ? `${class_subject_info.classname}${class_subject_info.section}-${class_subject_info.subject}`
                    : 'Choose Class & Subject'}
                </Typography>
              </SecondaryButton>
            )}
          </Box>
          <Box sx={{ width: { xs: '100%', md: pxTovW(484), lg: pxTovW(394) } }}>
            <SelectMenu
              nofocus
              placeholder="Search by Assessment Type"
              value={searchByAssessType ? searchByAssessType.name : ''}
              onChange={async (val: string) => {
                const selectedAssessmentType = assessmentFilterTypes.find(
                  (option) => option.name === val
                );
                setPageNumber(1);
                setSearchByAssessType(selectedAssessmentType);
                console.log('value:', value);
                await interactionEvent({
                  context: value === 'Assigned' ? 'Assigned' : 'Ended',
                  name: 'SEARCH_BY_ASSESSMENT_TYPE',
                  pathSegments: pathSegments,
                  isOffline: isOffline,
                });
                await interactionEvent({
                  context: 'Assessment_Type',
                  name:
                    val.trim() === ''
                      ? 'All'
                      : val.toUpperCase().replace(/ /g, '_'),
                  pathSegments: pathSegments,
                  isOffline: isOffline,
                });
              }}
              optionList={assessmentFilterTypes.filter(
                (option) => option.name !== 'Question Paper'
              )}
              rootStyles={{
                height: { xs: pxToRem(40), md: pxTovW(70), lg: pxTovW(56) },
                backgroundColor: '#FFFFFF',
                border: '1px solid #55ACFF',
                '.MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '&:focus-visible .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '& .MuiSelect-select > em': {
                  // backgroundColor: 'red',
                  fontStyle: 'normal !important',
                  fontFamily: 'Lato',
                },
                // borderRadius: { xs: pxToRem(15), md: pxTovW(15) },
                width: { xs: '100%', md: pxTovW(484), lg: pxTovW(394) },
              }}
              clearIcon={true}
            />
          </Box>

          <Box>
            <ModeOfConductionDropdown
              isEditing={true}
              iconName={
                modeOfConductionValue === 'All' || undefined
                  ? ''
                  : modeOfConductionValue === 'Geneo App'
                    ? 'mobile-app'
                    : 'clicker_icon'
              }
              isIconInside={true}
              value={modeOfConductionValue}
              onChange={(val) => onChangeModeOfConduction(val)}
              optionsList={modeOptions}
              customStyles={{
                height: { xs: pxToRem(40), md: pxTovW(70), lg: pxTovW(56) },
                backgroundColor: '#FFFFFF',
                border: '1px solid #55ACFF',
                '.MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '&:focus-visible .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '& .MuiSelect-select > em': {
                  // backgroundColor: 'red',
                  fontStyle: 'normal !important',
                  fontFamily: 'Lato',
                },
              }}
            />
          </Box>

          {/* <FilterSortPopup
            iconName="Filter"
            title="Filter"
            options={getAssessmentTypeByValue()}
          /> */}
          <Box
            sx={{
              marginY: { md: 'auto' },
              marginX: { xs: 'auto', md: 0 },
            }}
          >
            <FilterSortPopup
              iconName="Sort"
              title="Sort By"
              options={[
                'Date',
                'Submission',
                'Score: Low to High',
                'Score: High to Low',
              ]}
              sortFunction={SortFunction}
            />
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          // backgroundColor: 'red',
          paddingTop: { xs: pxToRem(20), md: pxTovW(40) },
          paddingBottom: { xs: pxToRem(20), md: pxTovW(40) },
          // maxHeight: '70vh',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        {loading === true ? (
          // <Loader />
          <ShimmerComponent />
        ) : error === true ? (
          <Typography>Error Occurred</Typography>
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: { xs: pxToRem(20), md: pxTovW(20) },
              width: { xs: '100%', md: pxTovW(1800), lg: pxTovW(1441) },
            }}
          >
            <Grid
              container
              // columns={{ xs: 1, md: 3 }}
              rowGap={3}
              // columnGap={'26px'}
              sx={{
                width: { xs: '100%', md: pxTovW(1800), lg: pxTovW(1441) },
              }}
            >
              {value === 'Draft' &&
                draft_homework &&
                draft_homework[pageNumber]?.map((card, index) => (
                  <Grid item xs={12} md={4} key={index}>
                    <ManageHomeworkCard
                      hwDraft={card}
                      subjectName={`${card.subject}`}
                      clickHandler={() =>
                        cardClickHandler(
                          card.assessmentId,
                          card.modeOfConduction,
                          card.moduleId
                        )
                      }
                      hwType="Draft"
                    />
                  </Grid>
                ))}

              {value === 'Assigned' &&
                assigned_homework &&
                assigned_homework[pageNumber]?.map((card, index) => (
                  <Grid item xs={12} md={4} key={index}>
                    {/* <ManageHomeworkCard
                      maxMarks={card.maxMarks}
                      submissionType={card.submissionType}
                      hwAssigned={card}
                      subjectName={card.subject}
                      clickHandler={() => cardClickHandler(card.homeworkId)}
                      hwType="Assigned"
                    /> */}
                    <AssessmentCard
                      homework={card}
                      assessCardType="Assigned"
                      chapterListPopupHandler={ChapterListPopupHandler}
                      onClick={() => {
                        cardClickHandler(
                          card.assessmentId,
                          card.modeOfConduction,
                          card.moduleId
                        );
                      }}
                      onDeleteClick={() => onDeleteClick(card)}
                      modeofConduction={card.modeOfConduction}
                      proctoring={
                        card.assignmentInfo?.find(
                          (info) =>
                            info.configName ===
                            AssignmentConfigEnum.ASSIGNMENT_CONFIG_PROCTORING
                        )?.isEnabled
                          ? true
                          : false
                      }
                      subjectList={getSubjectListForAssessmentCard(
                        card,
                        user_info?.teachClassSubjects
                      )}
                    />
                  </Grid>
                ))}

              {value === 'Ended' &&
                ended_homework &&
                ended_homework[pageNumber]?.map((card, index) => (
                  <Grid item xs={12} md={4} key={index}>
                    {/* <ManageHomeworkCard
                      maxMarks={card.maxMarks}
                      submissionType={card.submissionType}
                      hwAssigned={card}
                      subjectName={card.subject}
                      clickHandler={() => cardClickHandler(card.homeworkId)}
                      hwType="Ended"
                    /> */}
                    <AssessmentCard
                      homework={card}
                      assessCardType="Ended"
                      chapterListPopupHandler={ChapterListPopupHandler}
                      onClick={() =>
                        cardClickHandler(
                          card.assessmentId,
                          card.modeOfConduction
                        )
                      }
                      modeofConduction={card.modeOfConduction}
                      proctoring={
                        card.assignmentInfo?.find(
                          (info) =>
                            info.configName ===
                            AssignmentConfigEnum.ASSIGNMENT_CONFIG_PROCTORING
                        )?.isEnabled
                          ? true
                          : false
                      }
                      subjectList={getSubjectListForAssessmentCard(
                        card,
                        user_info?.teachClassSubjects
                      )}
                    />
                  </Grid>
                ))}
            </Grid>

            {showPagination() ? (
              <Pagination
                page={pageNumber}
                count={
                  value === 'Draft'
                    ? hw_info?.totalDraftPages
                    : value === 'Assigned'
                      ? hw_info?.totalAssignedPages
                      : value === 'Ended'
                        ? hw_info?.totalEndedPages
                        : 0
                }
                color="primary"
                onChange={async (
                  event: React.ChangeEvent<unknown>,
                  page: number
                ) => {
                  setPageNumber(page);
                  if (pageNumber !== page) {
                    await interactionEvent({
                      context: 'navigation_bar',
                      name: 'PAGE_CHANGE',
                      pathSegments: pathSegments,
                      isOffline: isOffline,
                    });
                  }
                }}
                sx={{
                  width: 'max-content',
                  margin: 'auto',
                  marginTop: isIpadOnly ? pxToRem(5) : 0,
                }}
              />
            ) : (
              <Typography variant="h2" fontWeight="bold" margin="auto">
                No {value} Assessments
              </Typography>
            )}
          </Box>
        )}
      </Box>
      <ActionsPopup
        open={deletionPopup}
        handleClose={() => setDeletionPopup(false)}
        fontSmall
        iconName="delete"
        popupText={`Are you sure you want to delete ${deleteAssessmentInfo.assessmentType ===
          AssessmentEnum.ASSESSMENT_HOMEWORK
          ? 'Homework'
          : 'Assessment'
          } ?`}
        yesClickHandler={(ev?: React.MouseEvent) => {
          ev?.stopPropagation();
          setDeletionPopup(false);
          deleteAssessment(deleteAssessmentInfo.assessmentId);
        }}
        noClickHandler={(ev?: React.MouseEvent) => {
          ev?.stopPropagation();
          setDeletionPopup(false);
        }}
      />
      <ClassAndSubjectPopup
        modalState={modalState}
        setModalState={setModalState}
        displayData={subjectsWithClass}
        classSubjectsList={user_info?.teachClassSubjects}
        classAndsubjectClickHandler={classAndsubjectClickHandler}
      />
      <AssementSelectionPopup
        open={assessmentSelectionPopupDisplay}
        selectedValue={selectedAssessment}
        optionClickHandler={optionSelectionHandler}
        submitClickHandler={createAssessmentNavigation}
        handleClose={() => {
          setSelectedAssessment(undefined);
          setAssessmentSelectionPopupDisplay(false);
        }}
        classInfo={`${class_subject_info?.classname}${class_subject_info?.section} - ${class_subject_info?.subject}`}
        isClickerEnabled={isClickerEnabled}
        isOMREnabled={isOMREnabled}
        isLiveQuizEnabled={isLiveQuizEnabled}
        selectedMode={selectedMode}
        setSelectedMode={setSelectedMode}
        showLearningHomework={learningHomeworkEnabled}
      />
      <AssessmentTopicPopup
        assessment={selectedHomework}
        open={chapterListPopup}
        handleClose={() => setChapterListPopup(false)}
      />

      <FASelectMultiSubjectsPopup
        open={faMultiSubjectsPopup}
        handleClose={() => {
          setFAMultiSubjectsPopup(false);
          setSelectedAssessment(undefined);
        }}
      />

      <QPGSelectMultiSubjectsPopup
        open={qpgSelectMultiSubjectsPopup}
        handleClose={() => {
          setQPGSelectMultiSubjectsPopup(false);
          setSelectedAssessment(undefined);
        }}
      />

      {isProjectAssessmentEnabled && (
        <ProjectSubjectSelectionPopup
          open={openProjectPopup}
          handleClose={() => { setOpenProjectPopup(false) }}
        />
      )}
      {(isClickerEnabled || isOMREnabled || isLiveQuizEnabled) && (
        <Dialog
          open={isOpenSelectModeOfConduction}
          onClose={() => {
            setIsOpenSelectModeOfConduction(false);
            setSelectedMode(undefined);
            dispatch(setModeOfConduction(getModeOfConductionEnum('Geneo App')));
          }}
          maxWidth={false} // Important to override default sizes like "md"
          fullWidth={false} // Prevent it from automatically stretching
          PaperProps={{
            sx: {
              width: { xs: '77%', md: pxTovW(950), lg: pxTovW(780) }, // custom responsive width
              borderRadius: pxToRem(12),
              position: 'relative',
              overflow: 'visible',
            },
          }}
        >
          <IconButton
            onClick={() => {
              setIsOpenSelectModeOfConduction(false);
              setSelectedMode(undefined);
              dispatch(
                setModeOfConduction(getModeOfConductionEnum('Geneo App'))
              );
            }}
            sx={{
              position: 'absolute',
              top: pxToRem(3),
              right: pxToRem(-45),
              backgroundColor: '#FFD700', // Yellow background like your screenshot
              color: 'white',
              '&:hover': {
                backgroundColor: '#FFC107',
              },
              zIndex: '100',
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent
            sx={{
              width: '100%',
              boxSizing: 'border-box',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'relative',
              paddingX: { xs: pxToRem(20), md: pxTovW(89) },
              paddingY: { xs: pxToRem(20), md: pxTovW(68) },
            }}
          >
            <ConductionButtonsComponent
              value={
                !selectedMode && class_subject_info?.isClickerSupported
                  ? 'clicker'
                  : selectedMode === 'Geneo Clicker'
                  ? 'clicker'
                  : selectedMode === 'Geneo Live Quiz'
                  ? 'live-quiz'
                  : selectedMode === 'OMR Test'
                  ? 'omr'
                  : 'mobile-app'
              }
              onChange={async (
                val: 'mobile-app' | 'clicker' | 'omr' | 'live-quiz'
              ) => {
                const modeString =
                  val === 'mobile-app'
                    ? 'Geneo App'
                    : val === 'clicker'
                    ? 'Geneo Clicker'
                    : val === 'live-quiz'
                    ? 'Geneo Live Quiz'
                    : 'OMR Test';

                setSelectedMode(modeString);
                if (modeString) {
                  await interactionEvent({
                    context: 'Mode_of_Conduction',
                    name: modeString.toUpperCase().replace(/\s+/g, '_'),
                    pathSegments: pathSegments,
                    isOffline: isOffline,
                  });
                }
              }}
              isOMREnabled={isOMREnabled}
              isClickerEnabled={isClickerEnabled}
              isLiveQuizEnabled={isLiveQuizEnabled}
            />

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                mt: { xs: pxToRem(20), md: pxTovW(40) },
              }}
            >
              <Box
                sx={{
                  width: { xs: pxToRem(230), md: pxTovW(650), lg: pxTovW(497) },
                }}
              >
                <PrimaryButton
                  fullWidth
                  onClick={() => {
                    // const finalMode = selectedMode || 'Geneo App'; // fallback
                    // dispatch(
                    //   setModeOfConduction(getModeOfConductionEnum(finalMode))
                    // );
                    const mode = resolveModeOfConduction(
                      selectedMode,
                      class_subject_info?.isClickerSupported,
                      isOMREnabled
                    );
                    dispatch(setModeOfConduction(mode));
                    // setSelectedMode(finalMode);
                    navigate(`${ASSESMENT_LIBRARY}`);
                  }}
                >
                  PROCEED
                </PrimaryButton>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      )}
    </Box>
  );
};

// =====================================================

const ShimmerComponent = () => {
  return (
    <Grid container rowGap={3} sx={{ width: { md: pxTovW(1100) } }}>
      {Array.from({ length: 12 }, (_, index) => (
        <Grid item xs={12} md={4} key={index}>
          <ShimmerManageHwCard key={index} />
        </Grid>
      ))}
    </Grid>
  );
};

// =====================================================

function getAssessmentTypeByValue() {
  return Object.keys(AssessmentEnum)
    .filter(
      (key) =>
        isNaN(Number(key)) &&
        key !== 'ASSESSMENT_UNDEFINED' &&
        key !== 'ASSESSMENT_DIAGNOSTICS'
    )
    .map((key) => key.replace(/_/g, ' ').toLowerCase())
    .map((name) => name.replace('assessment', '').trim())
    .map((name) =>
      name
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
        .join(' ')
    );
}

// =====================================================
